module.exports = __webpack_public_path__ + "static/img/faq.ce7effb6.png";